'use strict';

// src/index.ts
var isEdgeToEdge = () => true;
var controlEdgeToEdgeValues = (values) => {
};

exports.controlEdgeToEdgeValues = controlEdgeToEdgeValues;
exports.isEdgeToEdge = isEdgeToEdge;
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map